import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-16 mt-2 rounded-lg bg-white select-none hover:shadow-lg flex items-stretch transition-shadow" }
const _hoisted_2 = {
  class: "flex flex-col p-2",
  style: {"width":"calc(100% - 1rem)"}
}
const _hoisted_3 = { class: "font-bold text-base text-gray-600 overflow-hidden overflow-ellipsis whitespace-nowrap" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "text-gray-500 text-sm overflow-hidden overflow-ellipsis whitespace-nowrap" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "详情", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "删除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["flex-initial flex-shrink-0 w-4 rounded-l-lg", _ctx.classCourseCard])
    }, null, 2),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.course.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.course.teachers.join(',')), 1),
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_f_button, {
            class: "ml-1 rounded-md py-0 px-1.5",
            type: "primary",
            size: "small",
            onClick: _withModifiers(_ctx.handleClickDetailButton, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_f_button, {
            class: "ml-1 rounded-md py-0 px-1.5",
            type: "danger",
            size: "small",
            onClick: _withModifiers(_ctx.handleClickDeleteButton, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}